import React from 'react';
import { ArrowLongSVG } from './arrowLong.svg';
import { ArrowShortSVG } from './arrowShort.svg';
import { BacklogSVG } from './backlog.svg';
import { BookmarkSVG } from './bookmark.svg';
import { CalendarSVG } from './calendar.svg';
import { ChainsSVG } from './chains.svg';
import { ChartSVG } from './chart.svg';
import { ChevronSVG } from './chevron.svg';
import { ChevronsDoubleSVG } from './chevronsDouble.svg';
import { CitySVG } from './city.svg';
import { ColorSVG } from './color.svg';
import { CountrySVG } from './country.svg';
import { CrossSVG } from './cross.svg';
import { DisconnectSVG } from './disconnect.svg';
import { EditBoxSVG } from './editBox.svg';
import { EmailSVG } from './email.svg';
import { EngagementSVG } from './engagement.svg';
import { EventManagerSVG } from './eventManager.svg';
import { EyeSVG } from './eye.svg';
import { EyeOffSVG } from './eyeOff.svg';
import { FirstnameSVG } from './firstname.svg';
import { FlashMeetingSVG } from './flashMeeting.svg';
import { FolderOpenLightSVG } from './folderOpenLight.svg';
import { FolderOpenSolidSVG } from './folderOpenSolid.svg';
import { GearSVG } from './gear.svg';
import { GripSVG } from './grip.svg';
import { HelpSVG } from './help.svg';
import { HourglassSVG } from './hourglass.svg';
import { LanguageSVG } from './language.svg';
import { LastnameSVG } from './lastname.svg';
import { LightBulbSVG } from './lightBulb.svg';
import { LocationSVG } from './location.svg';
import { MagnifyingGlassSVG } from './magnifyingGlass.svg';
import { MagnifyingGlassMinusSVG } from './magnifyingGlassMinus.svg';
import { MagnifyingGlassPlusSVG } from './magnifyingGlassPlus.svg';
import { MinusSVG } from './minus.svg';
import { NewsSVG } from './news.svg';
import { NewsCheckSVG } from './newsCheck.svg';
import { NewsDeleteSVG } from './newsDelete.svg';
import { NewsPlusSVG } from './newsPlus.svg';
import { PieChartSVG } from './pieChart.svg';
import { PlusSVG } from './plus.svg';
import { PlusCircleSVG } from './plusCircle.svg';
import { QuestionMarkSVG } from './questionMark.svg';
import { SharedSVG } from './shared.svg';
import { SkillsSVG } from './skills.svg';
import { SortArrowDownSVG } from './sortArrowDown.svg';
import { SortArrowUpSVG } from './sortArrowUp.svg';
import { TimerSVG } from './timer.svg';
import { TitleSVG } from './title.svg';
import { TrashSVG } from './trash.svg';
import { UserSVG } from './user.svg';
import { WarningSVG } from './warning.svg';
import { NotesSVG } from './notes.svg';

export const svgs = {
  ArrowLongSVG,
  ArrowShortSVG,
  BacklogSVG,
  BookmarkSVG,
  CalendarSVG,
  ChainsSVG,
  ChartSVG,
  ChevronSVG,
  ChevronsDoubleSVG,
  CitySVG,
  ColorSVG,
  CountrySVG,
  CrossSVG,
  DisconnectSVG,
  EditBoxSVG,
  EmailSVG,
  EngagementSVG,
  EventManagerSVG,
  EyeSVG,
  EyeOffSVG,
  FirstnameSVG,
  FlashMeetingSVG,
  FolderOpenLightSVG,
  FolderOpenSolidSVG,
  GearSVG,
  GripSVG,
  HelpSVG,
  HourglassSVG,
  LanguageSVG,
  LastnameSVG,
  LightBulbSVG,
  LocationSVG,
  MagnifyingGlassSVG,
  MagnifyingGlassMinusSVG,
  MagnifyingGlassPlusSVG,
  MinusSVG,
  NewsSVG,
  NewsCheckSVG,
  NewsDeleteSVG,
  NewsPlusSVG,
  PieChartSVG,
  PlusSVG,
  PlusCircleSVG,
  QuestionMarkSVG,
  SharedSVG,
  SkillsSVG,
  SortArrowDownSVG,
  SortArrowUpSVG,
  TimerSVG,
  TitleSVG,
  TrashSVG,
  UserSVG,
  WarningSVG,
  NotesSVG
};

const SVGsGallery: React.FC = () => {
  return (
    <div className='grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-6 p-4'>
      {Object.entries( svgs ).map( ( [ name, SVG ] ) => {return (
        <div
          key={name}
          className='flex flex-col items-center justify-center p-4 border border-gray-200 rounded-md shadow-sm hover:shadow-md transition-shadow bg-white text-center'
        >
          <SVG width={48} height={48} />
          <span className='mt-2 text-sm break-words'>{name}</span>
        </div>
      );} )}
    </div>
  );
};

export default SVGsGallery;